import { useState, useEffect } from "react";
import { Typography, Box, Button } from "@mui/material";
import { UseDeliverycalendar } from "./UseDeliverycalendar";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import DaysCalendar from "./DaysCalendar";
import useDeliveryData from "./useDeliveryData";
import CheckIcon from "@mui/icons-material/Check";

export default function Deliverycalendar() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [deliveryName, setDeliveryName] = useState("پیک موتوری");
  const [deliveryMonths, setDeliveryYkMonths] = useState([]);
  const [deliveryYears, setDeliveryYears] = useState([]);
  const [deliveryTypeRes, setDeliveryTypeRes] = useState([]);
  const { getDeliveryTypes } = UseDeliverycalendar();
  const [deliveryObject, setDeliveryObject] = useState({
    deliveryType: undefined,
    year: undefined,
    month: undefined,
  });

  useEffect(() => {
    setProgress(true);
    getDeliveryTypes((DeliveryTypes) => {
      setDeliveryTypeRes(DeliveryTypes);
    }, true);
  }, []);

  const {
    getDeliveriesTypes,
    getYears,
    getSelectedYears,
    getMonths,
    getSelectedMonths,
  } = useDeliveryData(deliveryTypeRes ? deliveryTypeRes : []);

  useEffect(() => {
    if (deliveryTypeRes) {
      setDeliveryYears(getYears(deliveryName));
      setDeliveryYkMonths(
        getMonths(deliveryName, getSelectedYears(deliveryName).yearname)
      );
      setDeliveryObject({
        deliveryType: getDeliveriesTypes(deliveryName).deliveryType,
        year: getSelectedYears(deliveryName).yearname,
        month: getMonths(
          deliveryName,
          getSelectedYears(deliveryName).yearname
        ).find((d) => d.isselected === true)?.month,
      });
    }
  }, [deliveryTypeRes, deliveryName]);

  return (
    <Detail
      breadChilds={{
        title: "سفارشات",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: "/deliverycalendar",
          },
        ],
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          height: "100%",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
          <Button
            startIcon={deliveryName == "پیک موتوری" && <CheckIcon />}
            sx={{ width: "120px" }}
            variant={deliveryName == "پیک موتوری" ? "contained" : "outlined"}
            color={deliveryName == "پیک موتوری" ? "secondary" : "primary"}
            onClick={() => {
              setDeliveryObject({
                deliveryType: getDeliveriesTypes("پیک موتوری").deliveryType,
                year: undefined,
                month: undefined,
              });
              setDeliveryName("پیک موتوری");
              setDeliveryYears(getYears("پیک موتوری"));
              setDeliveryYkMonths([]);
            }}
          >
            پیک موتوری
          </Button>
          <Button
            startIcon={deliveryName == "پیک اکسپرس" && <CheckIcon />}
            sx={{ width: "120px" }}
            variant={deliveryName == "پیک اکسپرس" ? "contained" : "outlined"}
            color={deliveryName == "پیک اکسپرس" ? "secondary" : "primary"}
            onClick={() => {
              setDeliveryObject({
                deliveryType: getDeliveriesTypes("پیک اکسپرس").deliveryType,
                year: undefined,
                month: undefined,
              });
              setDeliveryName("پیک اکسپرس");
              setDeliveryYears(getYears("پیک اکسپرس"));
              setDeliveryYkMonths([]);
            }}
          >
            پیک اکسپرس
          </Button>
          <Button
            startIcon={deliveryName == "پست" && <CheckIcon />}
            sx={{ width: "120px" }}
            variant={deliveryName == "پست" ? "contained" : "outlined"}
            color={deliveryName == "پست" ? "secondary" : "primary"}
            onClick={() => {
              setDeliveryObject({
                deliveryType: getDeliveriesTypes("پست").deliveryType,
                year: undefined,
                month: undefined,
              });
              setDeliveryName("پست");
              setDeliveryYears(getYears("پست"));
              setDeliveryYkMonths([]);
            }}
          >
            پست
          </Button>
        </Box>
        {deliveryYears && deliveryYears.length ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              border: "1px solid #DCDCE4",
              borderRadius: 3,
              p: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              {deliveryYears.map((years) => {
                return (
                  <Box
                    key={years.year}
                    onClick={() => {
                      setDeliveryObject({
                        ...deliveryObject,
                        year: years.year,
                        month: undefined,
                      });
                      setDeliveryYkMonths(
                        getMonths("پیک موتوری", years.yearname)
                      );
                    }}
                    sx={{
                      color: deliveryObject.year == years.year ? "white" : "",
                      bgcolor:
                        deliveryObject.year == years.year
                          ? "secondary.main"
                          : "",
                      border: "1px solid #DCDCE4",
                      borderRadius: 1,
                      p: 0.5,
                      px: 2,
                      cursor: "pointer",
                    }}
                  >
                    <Typography>{years.yearname}</Typography>
                  </Box>
                );
              })}
            </Box>
            <Box
              sx={{
                // mt: deliveryMonths && deliveryMonths.length && 1,
                display: "flex",
                alignItems: "center",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              {deliveryMonths &&
                deliveryMonths.map((Months) => {
                  return (
                    <Box
                      key={Months.month}
                      onClick={() => {
                        setDeliveryObject({
                          ...deliveryObject,
                          month: Months.month,
                        });
                      }}
                      sx={{
                        color:
                          deliveryObject.month == Months.month ? "white" : "",
                        bgcolor:
                          deliveryObject.month == Months.month
                            ? "secondary.main"
                            : "",
                        border: "1px solid #DCDCE4",
                        borderRadius: 1,
                        p: 0.5,
                        px: 2,
                        cursor: "pointer",
                      }}
                    >
                      <Typography>{Months.monthname}</Typography>
                    </Box>
                  );
                })}
            </Box>
          </Box>
        ) : (
          ""
        )}

        {deliveryObject && deliveryObject.month && (
          <DaysCalendar selectedMonth={deliveryObject} />
        )}
      </Box>
    </Detail>
  );
}
